import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import CallIcon from "./images/call.svg";
import EmailIcon from "./images/email.svg";
import TextIcon from "./images/text.svg";
import H2 from "../../shared/h2/component";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { HELPLINE_NUMBER_AU, SMS_NUMBER_AU, SPECIALPAGETYPE, SUPPORT_EMAIL } from "../../../constants/app-constants";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

const ListingContactBottom = ({
    title = "Couldn’t find the perfect car?",
    selectedCity = {},
    specialPageType = ""
}) => {

    const onClick = (label) => {
        if (specialPageType === SPECIALPAGETYPE.LOCATION_BASED) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LISTING_PAGE, {
                eventAction: `cta_selected_${(selectedCity || {}).name}`,
                eventLabel: `option selected ${label}`
            });
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HOMEPAGE_GET_IN_TOUCH, {
                eventLabel: `option selected ${label}`
            });
        }
    };

    return (
        <div styleName={"styles.wrapper"}>
            <div className={"container"}>
                <H2 text={title} />
                <p>Let one of our friendly team know - we might have the perfect car waiting backstage.</p>
                <ul styleName={"styles.touchList"}>
                    <li onClick={() => onClick("call_us")} >
                        <a href={`tel:${HELPLINE_NUMBER_AU.value}`}>
                            <img src={CallIcon} alt="Call Us" /> {HELPLINE_NUMBER_AU.label}
                        </a>
                    </li>
                    <li onClick={() => onClick("email_us")}>
                        <a href={`mailto:${SUPPORT_EMAIL}`}>
                            <img src={EmailIcon} alt="Email Us" /> hello.au@cars24.com
                        </a>
                    </li>
                    <li onClick={() => onClick("text_us")}>
                        <a href={`sms:${SMS_NUMBER_AU.value}`}>
                            <img src={TextIcon} alt="Text Us" /> {SMS_NUMBER_AU.label}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

ListingContactBottom.propTypes = {
    title: PropTypes.string,
    selectedCity: PropTypes.object,
    specialPageType: PropTypes.string
};

export default ListingContactBottom;
